// BCM-898 · Goods Receipt Dashboard — labelled-field detail card with a row of
// horizontal labelled fields. Matches the mockups for PA4, PA8 (per check),
// PA10/PA11. fields = [{ label, value, red }]. Optional title and a right-aligned
// action (e.g. a Sync button), a note line, and a right-aligned footerAction
// (e.g. PA8's MARD Data Updated button) rendered BELOW the note, still inside
// this same card — not a separate block after all the cards.
// `passed` renders the green "success" variant (green background + check icon)
// used by PA8 for checks that pass; the default is the pink "failure" variant.
// `columns` overrides fieldGrid's default 3 columns (e.g. PA5's 4 fields on one row).
import React from "react";
import { Typography, Box } from "@material-ui/core";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { useGRStyles } from "../../goodsReceiptStyles";

const FieldCard = ({ title, fields, rightAction, note, passed, footerAction, columns }) => {
  const classes = useGRStyles();
  const gridStyle = columns ? { gridTemplateColumns: `repeat(${columns}, 1fr)` } : undefined;
  const buildFieldGrid = (gridClass) => (
    <div className={gridClass} style={gridClass === classes.fieldGrid ? gridStyle : undefined}>
      {(fields || []).map((f, i) => (
        <div key={`${f.label}-${i}`}>
          <div className={classes.fieldLabel}>{f.label}</div>
          <div className={`${classes.fieldValue} ${f.red ? classes.fieldValueRed : ""}`}>
            {f.value == null || f.value === "" ? "-" : f.value}
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className={passed ? classes.passCard : classes.failCard}>
      {title && (
        <div className={classes.failCardHead}>
          <Typography className={passed ? classes.passCardTitle : classes.failCardTitle}>
            {passed ? (
              <CheckCircleIcon style={{ fontSize: 18 }} />
            ) : (
              <WarningRoundedIcon style={{ fontSize: 18 }} />
            )}
            {title}
          </Typography>
          {rightAction}
        </div>
      )}
      {title ? (
        buildFieldGrid(classes.fieldGrid)
      ) : rightAction ? (
        // No title: keep the field row and the action button on one line,
        // right-aligned, with the fields spread out (matches the PA10/PA11
        // QA release card mockup).
        <div className={classes.fieldRowWithAction}>
          {buildFieldGrid(classes.fieldRowGrid)}
          {rightAction}
        </div>
      ) : (
        buildFieldGrid(classes.fieldGrid)
      )}
      {note && <Typography className={classes.noteLine}>{note}</Typography>}
      {footerAction && (
        <Box display="flex" justifyContent="flex-end" mt={1}>
          {footerAction}
        </Box>
      )}
    </div>
  );
};

export default FieldCard;
